export const FEED_RUN_STATUS = {
	DONE: 'done',
	ERROR: 'error',
	PROCESSING: 'processing',
	WAITING: 'waiting',
};

export const FEED_RUN_STATUS_CONFIG = {
	[FEED_RUN_STATUS.DONE]: { label: "Success", iconClass: "fas fa-check-circle is-success" },
	[FEED_RUN_STATUS.ERROR]: { label: "Error", iconClass: "fas fa-times-circle is-danger" },
	[FEED_RUN_STATUS.PROCESSING]: { label: "Processing", iconClass: "fas fa-spinner fa-spin" },
	[FEED_RUN_STATUS.WAITING]: { label: "Waiting", iconClass: "fas fa-clock" },
};

export function isErrorStatus(status) {
	return status === FEED_RUN_STATUS.ERROR;
}
